import { render, staticRenderFns } from "./logwood-packages-table.vue?vue&type=template&id=e5fe7288&scoped=true&"
import script from "./logwood-packages-table.vue?vue&type=script&lang=ts&"
export * from "./logwood-packages-table.vue?vue&type=script&lang=ts&"
import style0 from "./logwood-packages-table.vue?vue&type=style&index=0&id=e5fe7288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fe7288",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5fe7288')) {
      api.createRecord('e5fe7288', component.options)
    } else {
      api.reload('e5fe7288', component.options)
    }
    module.hot.accept("./logwood-packages-table.vue?vue&type=template&id=e5fe7288&scoped=true&", function () {
      api.rerender('e5fe7288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/logwood/components/logwood-packages-table.vue"
export default component.exports